import {OrderItem} from './order-item.entity';
import {OrderItemDTO} from '@features/sales/domain/models/order/order-item.model';
import {OrderType} from '@features/sales/domain/models/order/order-split.model';
import {OrderDTO, OrderStatus} from '../../models/order/order.model';

export class Order {
  private _totalAmount: number;
  private _type: OrderType;
  private _status: OrderStatus;
  private readonly _id: string;
  private readonly _accountId: string;
  private readonly _waiterId: string;
  private readonly _locationId: string;
  private readonly _cashDrawerId: string;
  private readonly _serviceId: string;
  private readonly _items: OrderItem[];

  constructor(dto: OrderDTO) {
    this._id = dto.id;
    this._status = dto.status;
    this._accountId = dto.accountId;
    this._waiterId = dto.waiterId;
    this._locationId = dto.locationId;
    this._cashDrawerId = dto.cashDrawerId;
    this._serviceId = dto.serviceId;
    this._totalAmount = dto.totalAmount;
    this._type = dto.type ?? OrderType.SALE;
    this._items = dto.entries.map((entry: OrderItemDTO) => new OrderItem(entry));
  }

  get id(): string {
    return this._id;
  }

  get accountId(): string {
    return this._accountId;
  }

  get type(): OrderType {
    return this._type;
  }

  get status(): OrderStatus {
    return this._status;
  }

  get isOpen(): boolean {
    return this._status === OrderStatus.OPEN;
  }

  get isPending(): boolean {
    return this._status === OrderStatus.PENDING;
  }

  get isProcessing(): boolean {
    return this._status === OrderStatus.PROCESSING;
  }

  markPending(): void {
    this._status = OrderStatus.PENDING;
  }

  settle(): void {
    this._status = OrderStatus.SETTLED;
  }

  markFailed(): void {
    this._status = OrderStatus.FAILED;
  }

  markProcessing(): void {
    this._status = OrderStatus.PROCESSING;
  }

  toDTO(): OrderDTO {
    return {
      id: this._id,
      type: this._type,
      status: this._status,
      accountId: this._accountId,
      waiterId: this._waiterId,
      locationId: this._locationId,
      cashDrawerId: this._cashDrawerId,
      serviceId: this._serviceId,
      totalAmount: this._totalAmount,
      entries: this._items.map((item) => item.toDTO()),
    };
  }
}
